<template>
    <div class="profile-tabs__wrapper">
        <tabs class="profile-tabs profile-tabs--active d-flex" v-if="donated.array.length && follows.array.length">
            <tab :name="tab.title" :selected="tab.selected" v-for="(tab, index) in [donated, follows]" :key="index">

                <div class="profile-tabs__scroll-wrapper">
                    <div class="profile-tabs__body" v-if="tab.title === $store.getters.t('user_dashboard_tabs_donated') && tab.array.length > 0">

                        <div class="profile-tabs__body-item d-flex" v-for="({pet = null, project = null, ...item},index) in tab.array" :key="index">

                            <template v-if="item && pet">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/pets/${item.pet_id}`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${pet.avatar.path.replace('original', 'avatar')}`" :alt="pet.name" v-if="pet.avatar">
                                        <span v-else v-text="getUserPM(pet.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/pets/${item.pet_id}`" class="profile-tabs__body-name">{{ pet.name }}</a>
                                    <div class="profile-tabs__body-info">{{item.total_donated}} EUR перечислено</div>

                                    <span class="tabs-icon d-flex" v-if="(pet.archive_reason && pet.archive_reason === 'home_found') && (pet.status && +pet.status === 0)">
                                    <img src="/assets/images/icons/home.svg" alt="">
                                </span>

                                </div>
                            </template>

                            <template v-if="item && project">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/projects/${item.project_id}`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${project.avatar.path.replace('original', 'avatar')}`" :alt="project.name" v-if="project.avatar">
                                        <span v-else v-text="getUserPM(project.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/projects/${item.project_id}`" class="profile-tabs__body-name">{{ project.name }}</a>
                                    <div class="profile-tabs__body-info">{{item.total_donated}} EUR перечислено</div>

                                    <span class="tabs-icon d-flex" v-if="(project.archive_reason && project.archive_reason === 'home_found') && (project.status && +project.status === 0)">
                                    <img src="/assets/images/icons/home.svg" alt="">
                                </span>

                                </div>
                            </template>


                        </div>

                    </div>
                    <div class="profile-tabs__body" v-else-if="tab.title === $store.getters.t('user_dashboard_tabs_follows')  && tab.array.length > 0">

                        <div class="profile-tabs__body-item d-flex" v-for="({target = null, ...item}, index) in tab.array" :key="index">

                            <template v-if=" item && item.target_type.indexOf('Pet') >= 0 ">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/pets/${item.target_id}`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${target.avatar.path.replace('original', 'avatar')}`" :alt="target.name" v-if="target.avatar">
                                        <span v-else v-text="getUserPM(target.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/pets/${item.target_id}`" class="profile-tabs__body-name">{{ target.name }}</a>
                                    <div class="profile-tabs__body-info">
                                        <span v-if="target.user && target.user.name">{{target.user.name + ', '}}</span>
                                        <span v-if="target.city && target.city.name">{{target.city.name}}</span>
                                    </div>
                                    <span class="tabs-icon d-flex" :style="{background: '#EAF1FC'}">
                                    <img src="/assets/images/icons/heart.svg" alt="">
                                </span>
                                </div>
                            </template>

                            <template v-if=" item && item.target_type.indexOf('Project') >= 0 ">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/projects/${item.target_id}`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${target.avatar.path.replace('original', 'avatar')}`" :alt="target.name" v-if="target.avatar">
                                        <span v-else v-text="getUserPM(target.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/projects/${item.target_id}`" class="profile-tabs__body-name">{{ target.name }}</a>
                                    <div class="profile-tabs__body-info">
                                        <span v-if="target.user && target.user.name">{{target.user.name + ', '}}</span>
                                        <span v-if="target.city && target.city.name">{{target.city.name}}</span>
                                    </div>
                                    <span class="tabs-icon d-flex" :style="{background: '#EAF1FC'}">
                                    <img src="/assets/images/icons/heart.svg" alt="">
                                </span>
                                </div>
                            </template>


                        </div>

                    </div>
                    <div class="profile-tabs__body profile-tabs__body--empty d-flex" v-else>
                        {{$store.getters.t('facilities_list_empty')}}
                    </div>
                </div>

            </tab>
        </tabs>

        <div class="profile-tabs"  :class="tabOpen ? 'profile-tabs--open' : ''" v-if="!donated.array.length || !follows.array.length">
            <div class="profile-tabs__header-text">
                {{ donated.array.length ? donated.title : follows.title }}
            </div>
            <transition name="slide" >

                <template  v-if="donated.array.length">
                    <div class="profile-tabs__scroll-wrapper">
                        <div class="profile-tabs__body" v-show="tabOpen">

                            <div class="profile-tabs__body-item d-flex" v-for="({pet = null, project = null,...item},index) in donated.array" :key="index">

                                <template v-if="item && pet">
                                    <div class="profile-tabs__body-header">
                                        <a :href="`/pets/${item.pet_id}`" class="profile-tabs__body-image">
                                            <img :src="`/storage/${pet.avatar.path.replace('original', 'avatar')}`" :alt="pet.name" v-if="pet.avatar">
                                            <span v-else v-text="getUserPM(pet.name || 'Anonymous')"></span>
                                        </a>
                                    </div>

                                    <div class="profile-tabs__body-content">
                                        <a :href="`/pets/${item.pet_id}`" class="profile-tabs__body-name">{{ pet.name }}</a>
                                        <div class="profile-tabs__body-info" v-text="">{{item.total_donated}} EUR перечислено</div>
                                        <span class="tabs-icon d-flex" v-if="(pet.archive_reason && pet.archive_reason === 'home_found') && (pet.status && +pet.status === 0)">
                                        <img src="/assets/images/icons/home.svg" alt="">
                                    </span>
                                    </div>
                                </template>

                                <template v-if="item && project">
                                    <div class="profile-tabs__body-header">
                                        <a :href="`/projects/${item.project_id}`" class="profile-tabs__body-image">
                                            <img :src="`/storage/${project.avatar.path.replace('original', 'avatar')}`" :alt="project.name" v-if="project.avatar">
                                            <span v-else v-text="getUserPM(project.name || 'Anonymous')"></span>
                                        </a>
                                    </div>

                                    <div class="profile-tabs__body-content">
                                        <a :href="`/projects/${item.project_id}`" class="profile-tabs__body-name">{{ project.name }}</a>
                                        <div class="profile-tabs__body-info">{{item.total_donated}} EUR перечислено</div>
                                        <span class="tabs-icon d-flex" v-if="(project.archive_reason && project.archive_reason === 'home_found') && (project.status && +project.status === 0)">
                                        <img src="/assets/images/icons/home.svg" alt="">
                                    </span>

                                    </div>
                                </template>


                            </div>

                        </div>
                    </div>
                </template>
                <template  v-else-if="follows.array.length">
                    <div class="profile-tabs__scroll-wrapper">
                        <div class="profile-tabs__body" v-show="tabOpen">

                            <div class="profile-tabs__body-item d-flex" v-for="({target = null, ...item},index) in follows.array" :key="index">

                                <template v-if=" item && item.target_type.indexOf('Pet') >= 0 ">
                                    <div class="profile-tabs__body-header">
                                        <a :href="`/pets/${item.target_id}`" class="profile-tabs__body-image">
                                            <img :src="`/storage/${target.avatar.path.replace('original', 'avatar')}`" :alt="target.name" v-if="target.avatar">
                                            <span v-else v-text="getUserPM(target.name || 'Anonymous')"></span>
                                        </a>
                                    </div>

                                    <div class="profile-tabs__body-content">
                                        <a :href="`/pets/${item.target_id}`" class="profile-tabs__body-name">{{ target.name }}</a>
                                        <div class="profile-tabs__body-info">
                                            <span v-if="target.user && target.user.name">{{target.user.name + ', '}}</span>
                                            <span v-if="target.city && target.city.name">{{target.city.name}}</span>
                                        </div>

                                        <span class="tabs-icon d-flex" :style="{background: '#EAF1FC'}">
                                        <img src="/assets/images/icons/heart.svg" alt="">
                                    </span>

                                    </div>
                                </template>

                                <template v-if=" item && item.target_type.indexOf('Project') >= 0 ">
                                    <div class="profile-tabs__body-header">
                                        <a :href="`/projects/${item.target_id}`" class="profile-tabs__body-image">
                                            <img :src="`/storage/${target.avatar.path.replace('original', 'avatar')}`" :alt="target.name" v-if="target.avatar">
                                            <span v-else v-text="getUserPM(target.name || 'Anonymous')"></span>
                                        </a>
                                    </div>

                                    <div class="profile-tabs__body-content">
                                        <a :href="`/projects/${item.target_id}`" class="profile-tabs__body-name">{{ target.name }}</a>
                                        <div class="profile-tabs__body-info">
                                            <span v-if="target.user && target.user.name">{{target.user.name + ', '}}</span>
                                            <span v-if="target.city && target.city.name">{{target.city.name}}</span>
                                        </div>

                                        <span class="tabs-icon d-flex" :style="{background: '#EAF1FC'}">
                                        <img src="/assets/images/icons/heart.svg" alt="">
                                    </span>

                                    </div>
                                </template>

                            </div>

                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="profile-tabs__scroll-wrapper">
                        <div class="profile-tabs__body profile-tabs__body--empty d-flex" v-show="tabOpen">

                            Список пуст

                        </div>
                    </div>
                </template>

            </transition>

        </div>

    </div>
</template>

<script>

import Tabs from '../tabs/Tabs';
import Tab from '../tabs/Tab';

export default {
    name: "UserDashboardTabs",
    props:['user', 'followList'],
    components: {Tab, Tabs},
    data(){
        return{

            donatedPage: 1,
            followsPage: 1,

            tabOpen: true,

            donated: {
                title: this.$store.getters.t('user_dashboard_tabs_donated'),
                selected: true,
                array: [],
                meta: null
            },
            follows:{
                title: this.$store.getters.t('user_dashboard_tabs_follows'),
                selected: false,
                array: [],
                meta: null
            },
        }
    },



    mounted(){
        this.getDonated()

        this.follows.array = this.followList

    },

    methods:{

        getDonated(){
            axios
                .get(`/user/${this.user.id}/donations/by-user`,{params: {page: this.donatedPage, per_page: 50}})
                .then(response => {
                    response = response.data

                    if(response.success){

                        this.donated.array = response.data

                    }

                })
                .catch(function(error) {
                    console.log('1', error)
                })
        },

        getUserPM(name){
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
    },

    watch:{
        donatedPage(){
            this.getDonated()
        },

        followList(){
            this.follows.array = this.followList
        }

    }


}
</script>

<style scoped>

</style>
